import styled from "styled-components";

import {
  Button,
  Caption,
  Card,
  Divider,
  Flex,
  ParagraphMd,
  Textarea,
} from "@olist/design-system";
import { themes } from "@olist/design-system-tokens";
import { Container } from "@olist/templates";

export const TicketWrapper = styled(Container)`
  min-height: 70vh;
  padding-bottom: 16px;
`;

export const LoadingWrapper = styled(Flex)`
  align-items: center;
  height: 100%;
  justify-content: center;
  min-height: 70vh;
`;

export const TicketDescription = styled(Flex)`
  flex-direction: column;

  p {
    padding: 16px 0;
  }
`;

export const TicketCard = styled(Card)`
  height: auto;
  margin-right: 2%;
`;

export const TicketCardHeader = styled(Card.Body)`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.olist.color.neutral.soft};
  display: flex;
  height: auto;
  justify-content: flex-start;
  padding: 16px;
`;

export const TicketCardBody = styled(Card.Body)`
  height: 100%;
  padding: 16px;

  span#description {
    border-radius: 6px;
  }
`;

export const TicketDiscussionCardBody = styled(Card.Body)`
  height: 100%;
  padding: 0;
`;

export const TicketDetailsCard = styled(Card)`
  border: 1px solid ${({ theme }) => theme.olist.color.neutral.soft};
  height: auto;
`;

export const TicketDiscussion = styled(Flex)`
  flex-direction: column;
  margin-bottom: 16px;
  min-height: 500px;
  overflow-y: auto;
  padding: 32px 24px;
  row-gap: 16px;
`;

export const TicketMessage = styled(Flex)`
  flex-direction: column;
  margin-bottom: 16px;
  overflow-y: auto;
  padding: 32px 24px;
  row-gap: 16px;
`;

export const TicketInfo = styled(Flex)`
  align-items: center;
  color: ${themes.olist.base.color.neutral.base};
  column-gap: ${themes.olist.base.spacing.inline.small};
  flex-shrink: 1;
  justify-content: space-between;
  padding-bottom: 16px;
`;

export const TicketInfoLabel = styled.span`
  font-weight: bold;
  min-width: 40%;
`;

export const TicketInfoValue = styled.span`
  font-size: 14px;
  text-align: right;
  word-break: break-all;
`;

export const TicketDivider = styled(Divider)`
  padding-bottom: 16px;
`;

export const TicketParagraph = styled(ParagraphMd)`
  font-weight: bold;
  margin-bottom: 0;
`;

export const TicketCaption = styled(Caption)`
  color: ${themes.olist.base.color.neutral.base};
  margin-top: 0;
`;

export const TicketResponsible = styled.div`
  padding-left: 16px;
`;

export const TicketReply = styled(Flex)`
  align-items: flex-start;
  flex-direction: column;
  padding: 16px;

  div:first-child {
    margin-bottom: 4px;
    width: 100%;
  }
`;

export const ButtonsWrapper = styled(Flex)`
  align-items: center;
  justify-content: flex-end;
  width: 100%;

  div {
    div {
      width: initial;
      padding: 5px;
      margin-top: 2px;
      display: flex;
      align-items: center;
    }

    button {
      font-size: 0;
      padding: 12px 8px 12px 24px;

      svg {
        height: 22px;
        width: 22px;
      }
    }
  }
`;

export const SubmitButton = styled(Button)`
  margin-right: 8px;
`;

export const CommentInput = styled(Textarea)`
  width: 100%;
`;

export const Description = styled(Caption)`
  word-wrap: break-word;
`;

export const AttachementImage = styled.img`
  border: 1px solid ${({ theme }) => theme.olist.color.neutral.soft};
  border-radius: 4px;
  height: 80px;
  object-fit: contain;
  width: 80px;
`;

export const ImageNameDownload = styled(Caption)`
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.olist.color.primary.base};
  }
`;
